<div class="h-screen flex flex-row min-h-screen">
  <app-side-nav></app-side-nav>

  <div
    class="flex-grow bg-primaryMainLight dark:bg-primaryMainDark overflow-auto"
  >
    <div
      class="transition-all duration-300 ease-in-out h-auto w-auto max-w-full scrollbar-none"
    >
      <app-header></app-header>
    </div>
    <div class="flex-1 overflow-y-visible px-10 pb-10 pt-4">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
